import { 
  LayoutDashboard, 
  BarChart4, 
  GraduationCap, 
  Flame, 
  Lightbulb, 
  FileSearch, 
  ShieldCheck, 
  ListChecks, 
  GitFork, 
  Users2, 
  Settings, 
  User,
  BeakerIcon,
  Globe,
  Shield,
  Megaphone,
  LucideIcon
} from "lucide-react";

export interface NavItemType {
  title: string;
  href?: string;
  icon: LucideIcon;
  color: string;
  children: NavItemType[];
}

export const navItems: NavItemType[] = [
  {
    title: "Dashboard",
    href: "/dashboard",
    icon: LayoutDashboard,
    color: "text-sky-500",
    children: []
  },
  // {
  //   title: "Analytics",
  //   href: "/analytics",
  //   icon: BarChart4,
  //   color: "text-orange-500",
  //   children: []
  // },
  // {
  //   title: "Courses",
  //   href: "/courses",
  //   icon: GraduationCap,
  //   color: "text-amber-500",
  //   children: []
  // },
  // {
  //   title: "AEOPulse",
  //   href: "/aeopulse",
  //   icon: Flame,
  //   color: "text-red-500",
  //   children: [
  //     {
  //       title: "AEO Analyzer",
  //       href: "/aeopulse/analyzer",
  //       icon: Lightbulb,
  //       color: "text-yellow-500",
  //       children: []
  //     },
  //     {
  //       title: "Content Generator",
  //       href: "/aeopulse/content-generator",
  //       icon: FileSearch,
  //       color: "text-green-500",
  //       children: []
  //     },
  //     {
  //       title: "Visual Pulse AI",
  //       href: "/aeopulse/visualpulse-ai",
  //       icon: ShieldCheck,
  //       color: "text-blue-500",
  //       children: []
  //     }
  //   ]
  // },
  // {
  //   title: "InsightRank",
  //   href: "/insight-rank",
  //   icon: ListChecks,
  //   color: "text-purple-500",
  //   children: []
  // },
  // {
  //   title: "Ruby AIssist",
  //   href: "/ruby-copilot",
  //   icon: GitFork,
  //   color: "text-pink-500",
  //   children: []
  // },
  // {
  //   title: "ReviewLab",
  //   href: "/review-lab",
  //   icon: Users2,
  //   color: "text-teal-500",
  //   children: []
  // },
  // {
  //   title: "Brandify",
  //   href: "/brandify",
  //   icon: ShieldCheck,
  //   color: "text-lime-500",
  //   children: []
  // },
  // {
  //   title: "OutreachHub™",
  //   href: "/pr-media",
  //   icon: Megaphone,
  //   color: "text-rose-500",
  //   children: []
  // },
  // {
  //   title: "WebForge AI",
  //   href: "/webforge-ai",
  //   icon: Globe,
  //   color: "text-indigo-500",
  //   children: []
  // },
  // {
  //   title: "Security Center",
  //   href: "/security",
  //   icon: Shield,
  //   color: "text-red-600",
  //   children: []
  // },
  // {
  //   title: "Ruby AIssist V2",
  //   href: "/ruby-aissist-v2",
  //   icon: GitFork,
  //   color: "text-purple-500",
  //   children: []
  // },
  {
    title: "Ruby AIssist",
    href: "/ruby-aissist",
    icon: GitFork,
    color: "text-purple-500",
    children: []
  },
  // {
  //   title: "Testing Lab",
  //   href: "/testing-lab",
  //   icon: BeakerIcon,
  //   color: "text-amber-500",
  //   children: []
  // },
  // {
  //   title: "Resource Vault",
  //   href: "/resource-vault",
  //   icon: FileSearch,
  //   color: "text-violet-500",
  //   children: []
  // },
  {
    title: "Resource Vault",
    href: "/resource-vault",
    icon: FileSearch,
    color: "text-purple-400",
    children: []
  },
  // {
  //   title: "Project Management",
  //   href: "/project-management",
  //   icon: ListChecks,
  //   color: "text-orange-500",
  //   children: [
  //     {
  //       title: "Projects",
  //       href: "/project-management/projects",
  //       icon: ListChecks,
  //       color: "text-yellow-500",
  //       children: []
  //     },
  //     {
  //       title: "Tasks",
  //       href: "/project-management/tasks",
  //       icon: ListChecks,
  //       color: "text-green-500",
  //       children: []
  //     },
  //     {
  //       title: "Documentation",
  //       href: "/project-management/documentation",
  //       icon: ListChecks,
  //       color: "text-blue-500",
  //       children: []
  //     },
  //     {
  //       title: "Knowledge Base",
  //       href: "/project-management/knowledge-base",
  //       icon: ListChecks,
  //       color: "text-indigo-500",
  //       children: []
  //     },
  //     {
  //       title: "Ideas",
  //       href: "/project-management/ideas",
  //       icon: ListChecks,
  //       color: "text-purple-500",
  //       children: []
  //     },
  //     {
  //       title: "Bug Tracker",
  //       href: "/project-management/bug-tracker",
  //       icon: ListChecks,
  //       color: "text-pink-500",
  //       children: []
  //     },
  //     {
  //       title: "Team Management",
  //       href: "/project-management/team-management",
  //       icon: Users2,
  //       color: "text-teal-500",
  //       children: []
  //     }
  //   ]
  // },
  {
    title: "Subscriptions",
    href: "/subscriptions",
    icon: ListChecks,
    color: "text-fuchsia-500",
    children: []
  },
  {
    title: "Settings",
    href: "/settings",
    icon: Settings,
    color: "text-slate-500",
    children: []
  },
  {
    title: "Account",
    href: "/account",
    icon: User,
    color: "text-stone-500",
    children: []
  }
];
